module.exports = __webpack_public_path__ + "static/assets/c3bca105a5d17b3c552afbfacca6d9e2.svg";